export default __webpack_public_path__ + "static/cs-email-automation--mobile-fb4f1b2eb79459f96da9ac910847bdb3.jpg";